import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { CheckCircle } from "@phosphor-icons/react";
import PageSEO from "@/components/PageSEO";

const VALUES = ["Integrity", "Transparency", "Innovation", "Excellence", "Partnership", "Accountability", "Sustainability"];

export default function About() {
  return (
    <div>
      <PageSEO
        title="About Mayoto"
        description="Mayoto is a Nigerian investment company building structured, transparent investment opportunities across Real Estate, Agriculture and Strategic Business sectors. Learn our mission, values and long-term thinking."
        canonicalPath="/about"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-28">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">ABOUT MAYOTO</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="about-title">
            A Nigerian investment company built for long-term thinking.
          </h1>
          <div className="mt-8 grid md:grid-cols-2 gap-8 max-w-4xl">
            <p className="text-slate-700 leading-relaxed">
              Mayoto is a Nigerian investment company committed to creating structured investment opportunities and strategic partnerships across key sectors of the economy.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Our current investment focus is Real Estate, Agriculture, and carefully selected Strategic Business Investments. We believe wealth creation should be approached with professionalism, transparency, responsible management and long-term thinking.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-wide grid lg:grid-cols-2 gap-12">
          <Reveal>
            <div className="bg-[#0a1128] text-white rounded-3xl p-10 lg:p-14 h-full">
              <p className="text-[#d4af37] font-display font-bold tracking-[0.25em] text-xs">OUR VISION</p>
              <p className="mt-4 font-display font-bold text-2xl sm:text-3xl leading-tight text-white">
                To become one of Africa's most trusted investment companies, creating sustainable wealth opportunities through innovation, strategic partnerships, and responsible investment.
              </p>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="bg-white border border-slate-200 rounded-3xl p-10 lg:p-14 h-full">
              <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">OUR MISSION</p>
              <p className="mt-4 font-display font-bold text-2xl sm:text-3xl leading-tight text-[#0a1128]">
                To provide accessible investment opportunities, build long-term value for investors and partners, promote responsible investment practices, and contribute to economic growth.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-24 bg-[#f8fafc]">
        <div className="container-wide">
          <Reveal>
            <SectionHeader eyebrow="OUR VALUES" title="What we stand for." description="Seven principles that shape every decision we make at Mayoto." />
          </Reveal>
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {VALUES.map((v, i) => (
              <Reveal key={v} delay={i * 60}>
                <div className="card-lift bg-white border border-slate-200 rounded-2xl p-6 h-full">
                  <CheckCircle size={22} weight="fill" className="text-[#00b4d8]" />
                  <p className="mt-4 font-display font-bold text-lg text-[#0a1128]">{v}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
